import { render, staticRenderFns } from "./ReportLearnChart.vue?vue&type=template&id=626e8279&"
import script from "./ReportLearnChart.vue?vue&type=script&lang=ts&"
export * from "./ReportLearnChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports